import React from "react";
import {SearchForm} from "./searchForm";
import SupplierList from "./supplierList";

const Supplier = () => {
    return (
        <>
            <SearchForm/>
            <SupplierList/>
        </>
    )
}
export default Supplier